import React from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { useTranslation } from 'react-i18next';

import { TabGymBasicData } from './tabs/TabGymBasicData';
import { TabGymResponsibles } from './tabs/TabGymResponsibles';
import { TabGymLicenses } from './tabs/TabGymLicenses';
import { TabGymAnnuities } from './tabs/TabGymAnnuities';

/**
 * Dialog do Dojo - orquestra as 4 tabs.
 * Nao gerencia estado proprio - recebe tudo via props do GymList.
 */
export function GymFormDialog({
    // Dialog control
    visible,
    onHide,
    onSave,

    // Form state
    gym,
    onInputChange,
    submitted,
    activeIndex,
    setActiveIndex,

    // Basic data
    setStreetNumber,
    states,
    selectedState,
    onStateChange,
    checked,
    setChecked,

    // Responsibles
    onAddResponsible,
    onDeleteResponsible,
    onAddTechnical,
    onDeleteTechnical,

    // Licenses
    onAddLicense,
    onEditLicense,
    onDeleteLicense,

    // Annuities
    onAddAnnuity,
    onEditAnnuity,
    onDeleteAnnuity,
    apiError,
}) {
    const { t } = useTranslation();

    const footer = (
        <>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Save" icon="pi pi-check" onClick={onSave} />
        </>
    );

    return (
        <Dialog
            visible={visible}
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '60vw' }}
            header={t('msg.jkaGyms')}
            modal
            className="p-fluid"
            footer={footer}
            onHide={onHide}
        >
            {apiError && (
                <Message
                    severity="error"
                    text={apiError}
                    className="w-full mb-3"
                    style={{ justifyContent: 'flex-start' }}
                />
            )}
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Dados básicos">
                    <TabGymBasicData
                        gym={gym}
                        onInputChange={onInputChange}
                        submitted={submitted}
                        setStreetNumber={setStreetNumber}
                        states={states}
                        selectedState={selectedState}
                        onStateChange={onStateChange}
                        checked={checked}
                        setChecked={setChecked}
                    />
                </TabPanel>

                <TabPanel header={t('msg.jkaResponsibles')}>
                    <TabGymResponsibles
                        gym={gym}
                        onAddResponsible={onAddResponsible}
                        onDeleteResponsible={onDeleteResponsible}
                        onAddTechnical={onAddTechnical}
                        onDeleteTechnical={onDeleteTechnical}
                    />
                </TabPanel>

                <TabPanel header={t('msg.jkaLicense')}>
                    <TabGymLicenses
                        gym={gym}
                        onAdd={onAddLicense}
                        onEdit={onEditLicense}
                        onDelete={onDeleteLicense}
                    />
                </TabPanel>

                <TabPanel header={t('msg.jkaAnnuity')}>
                    <TabGymAnnuities
                        gym={gym}
                        onAdd={onAddAnnuity}
                        onEdit={onEditAnnuity}
                        onDelete={onDeleteAnnuity}
                    />
                </TabPanel>
            </TabView>
        </Dialog>
    );
}
